import { render, staticRenderFns } from "./meClientes.vue?vue&type=template&id=e2f48d1a&"
import script from "./meClientes.vue?vue&type=script&lang=js&"
export * from "./meClientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports